import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import Container from './ui/Container';
import './NotFoundPage.css';

const NotFoundPage = () => {
  return (
    <div className="not-found-page page-with-header">
      <Helmet>
        <title>Page Not Found - PySolutions</title>
        <meta name="description" content="The page you're looking for doesn't exist. Return to PySolutions homepage for Python development services." />
        <meta name="robots" content="noindex, nofollow" />
        <link rel="canonical" href="https://pysolutions.dev/404" />
      </Helmet>
      
      <section className="not-found-section section">
        <Container>
          <div className="not-found-content">
            <div className="error-code">404</div>
            <h1 className="error-title">Page Not Found</h1>
            <p className="error-description">
              The page you're looking for doesn't exist or has been moved.
              Let's get you back on track to what you came for.
            </p>
            
            <div className="error-actions">
              <Link to="/" className="btn-primary">
                <span>Go Home</span>
                <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                </svg>
              </Link>
              
              <Link to="/contact" className="btn-secondary">
                <span>Contact Us</span>
                <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                </svg>
              </Link>
            </div>
            
            <div className="error-suggestions">
              <h3>Looking for something specific?</h3>
              <div className="suggestion-links">
                <Link to="/about">About PySolutions</Link>
                <Link to="/contact">Get in Touch</Link>
                <Link to="/#services">Our Services</Link>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </div>
  );
};

export default NotFoundPage; 